"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommunityStaticElementsLists = useCommunityStaticElementsLists;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _utils = require("./utils");
var _context = require("./context");
var _utils2 = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function useCommunityStaticElementsLists(StaticChatPreview, onChannelSelect) {
  var _useCustomChatContext = (0, _context.useCustomChatContext)(),
    showStaticChannels = _useCustomChatContext.showStaticChannels,
    customChannel = _useCustomChatContext.customChannel;
  // We need to find the preview items by types to pass it to the corresponding chat list
  // We only have static channels of this 2 types now, since emergency is a single one and conversationals are all dynamic
  var gettingStartedChannelTypes = [_utils2.COMMUNITY_CHANNEL_TYPES.GETTING_STARTED];
  var groupChatsChannelTypes = Object.values(_utils2.SUPPORT_GROUP_CHANNEL_TYPES);
  var staticPreviewElements = (0, _react.useMemo)(function () {
    return (0, _lodash.reduce)(_utils.staticChannelItems, function (acc, staticChannelItem) {
      if (!staticChannelItem) {
        return acc;
      }
      var staticElement = /*#__PURE__*/_react.default.createElement(StaticChatPreview, {
        title: staticChannelItem === null || staticChannelItem === void 0 ? void 0 : staticChannelItem.name,
        onSelect: function onSelect() {
          return onChannelSelect({
            id: staticChannelItem === null || staticChannelItem === void 0 ? void 0 : staticChannelItem.id
          });
        },
        isActive: (staticChannelItem === null || staticChannelItem === void 0 ? void 0 : staticChannelItem.id) === (customChannel === null || customChannel === void 0 ? void 0 : customChannel.staticChannelId),
        key: staticChannelItem === null || staticChannelItem === void 0 ? void 0 : staticChannelItem.id
      });
      if ((0, _lodash.includes)(gettingStartedChannelTypes, staticChannelItem.type)) {
        acc.gettingStartedStaticElements.push(staticElement);
        return acc;
      }
      if ((0, _lodash.includes)(groupChatsChannelTypes, staticChannelItem.type)) {
        acc.groupChatsStaticElements.push(staticElement);
        return acc;
      }
    }, {
      gettingStartedStaticElements: [],
      groupChatsStaticElements: []
    });
  }, [_utils.staticChannelItems]);
  if (!showStaticChannels) {
    return {
      gettingStartedStaticElements: null,
      groupChatsStaticElements: null
    };
  }
  return staticPreviewElements;
}